export default __webpack_public_path__ + "static/ExtractTransformLoad-a85f039643ef58a152e496a19f3517a6.png";